/**
 * Helpers for Land Registry sales rows (tenure, category, same-day notes).
 */

export function saleMetaParts(sale) {
  const parts = [];
  if (sale?.sale_date) parts.push(sale.sale_date);
  if (sale?.property_type) parts.push(sale.property_type);
  if (sale?.duration_label) parts.push(sale.duration_label);
  if (sale?.ppd_category_label) parts.push(sale.ppd_category_label);
  return parts;
}

export function saleMetaLine(sale) {
  return saleMetaParts(sale).join(' · ');
}
